import React, { useContext } from 'react'
import { Grid } from '@mui/material'
import clsx from 'clsx'

import { GridContext } from './GridContext'
import { MuiGridProps } from './GridContainer'
import { ColStyleProps, useColStyles } from './GridStyles'

// when adding Props, dont forget to extract them
// so that rest props can safely be passed to <Grid>
type Props = MuiGridProps & ColStyleProps & {
  className?: string
}

const Col: React.FC<Props> = (props) => {
  const { spacingHorizontal, className, ...rest } = props
  const { defaultColWidth, gridSpacing } = useContext(GridContext)
  const s = useColStyles({ spacingHorizontal: spacingHorizontal || gridSpacing })

  return <Grid
    item
    xs={defaultColWidth}
    className={clsx(s.spacingHorizontal, className)}
    {...rest}
  >
    {props.children}
  </Grid>
}

export default Col
